import { AbstractStorageProvider } from "./AbstractStorageProvider.js";
class MemoryStorageProvider extends AbstractStorageProvider {
  async get(key) {
    return this.store.get(key);
  }
  async set(key, value) {
    this.store.set(key, value);
  }
  async has(key) {
    return this.store.has(key);
  }
  async delete(key) {
    this.store.delete(key);
  }
}
export {
  MemoryStorageProvider
};
//# sourceMappingURL=MemoryStorageProvider.js.map
